import { createFileRoute, Link, Outlet, notFound, redirect } from "@tanstack/react-router";
import { api } from "@/lib/api";
import { AdminReauthModal } from "./-components/AdminReauthModal";
import { useAdminReauth } from "./-components/useAdminReauth";

interface MeUser {
  role: string;
  mfa_enabled_at: string | null;
}

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    const result = await api.get<{ user: MeUser | null }>("/v1/auth/me");
    const user = result.ok ? (result.body?.user ?? null) : null;
    if (!user || user.role !== "admin") {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }
    if (!user.mfa_enabled_at) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/me/mfa/enroll" });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { modalOpen, onReauthSuccess, onReauthClose } = useAdminReauth();

  return (
    <div className="admin-layout">
      <nav className="admin-nav" aria-label="Admin navigation">
        <Link to="/admin" className="admin-nav__link">
          OVERVIEW
        </Link>
        <Link to="/admin/flags" className="admin-nav__link">
          FLAGS
        </Link>
        <Link to="/admin/users" className="admin-nav__link">
          USERS
        </Link>
        <Link to="/admin/pricing" className="admin-nav__link">
          PRICING
        </Link>
      </nav>
      <div className="admin-content">
        <Outlet />
      </div>
      {modalOpen && <AdminReauthModal onSuccess={onReauthSuccess} onClose={onReauthClose} />}
    </div>
  );
}
